import _ from "lodash";

/**
 * Twitter Picker(React-Color) 기본 색 팔레트
 */
const TextColorPalette = [
  "#06ABD8",
  "#FF6900",
  "#FCB900",
  "#7BDCB5",
  "#00D084",
  //"#8ED1FC",
  "#fff",
  "#ABB8C3",
  "#EB144C",
  "#F78DA7",
  "#9900EF",
];

const Annotation = {
  TextColorPalette,
};

export default Annotation;
